export const SET_SELECTED_PROJECT = 'SET_SELECTED_PROJECT';
export const SET_SELECTED_ELEMENT = 'SET_SELECTED_ELEMENT';

export const setSelectedProject = (selectedProject) => ({ type: SET_SELECTED_PROJECT, selectedProject });

export const setSelectedElement = (selectedElement) => ({ type: SET_SELECTED_ELEMENT, selectedElement });